import { Datepicker } from "vanillajs-datepicker";
import $ from "jquery";

import select2 from "select2";
select2($);
//select2 styling

import { getUrlParameter, showLoadingBar, removeLoadingBar, sendEvent } from "./global.js";
import { resetSubmitBtn } from "./form.js";
import AOS from "aos";

import { UAParser } from "ua-parser-js";
window.UAParser = UAParser;


var currentPage = 1;
var joinUsForm = $("form#join-us-form");
//var joinUsValidation = joinUsForm.parsley();
var donationAmount = 3;
var manualAddress = false;

//Tracking variables for analytics, to prevent analytics being sent multiple times
var trackingName = "New membership sign up";
var trackedPages = {
	page1: false,
	page2: false,
	page3: false,
	page4: false,
};
var entryTime = Date.now(); // Record entry time

var donationPromptDismissed = false;

var membershipType,
	showVideo = null,
	freeMembership = false,
	newPage,
	prevPage,
	nextPage,
	response;

let csrfTokenName = window.csrfTokenName || null;
let csrfTokenValue = window.csrfTokenValue || null;

const syncCsrfTokens = (payload = {}) => {
	if (payload.csrfTokenName) {
		csrfTokenName = payload.csrfTokenName;
	} else if (window.csrfTokenName) {
		csrfTokenName = window.csrfTokenName;
	}

	if (payload.csrfTokenValue) {
		csrfTokenValue = payload.csrfTokenValue;
	} else if (window.csrfTokenValue) {
		csrfTokenValue = window.csrfTokenValue;
	}
};

const appendCsrfField = (formData) => {
	if (!Array.isArray(formData)) {
		return;
	}
	if (csrfTokenName && csrfTokenValue) {
		formData.push({ name: csrfTokenName, value: csrfTokenValue });
	}
};

const applyCsrfToPayload = (payload) => {
	if (csrfTokenName && csrfTokenValue) {
		payload[csrfTokenName] = csrfTokenValue;
	}
	return payload;
};

syncCsrfTokens();

if ((!csrfTokenName || !csrfTokenValue) && typeof window.refreshCsrfContext === "function") {
	window.refreshCsrfContext()
		.then(() => {
			syncCsrfTokens();
		})
		.catch(() => {
			// Ignore refresh errors here; form submissions will attempt with existing tokens.
		});
}

window.addEventListener("eauk:user-data", (event) => {
	syncCsrfTokens(event.detail || {});
});

function validatePhone(txtPhone) {
	var a = document.getElementById(txtPhone).value;
	//if is not empty
	if (a.length == 0) {
		return true;
	}
	var filter = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
	if (filter.test(a)) {
		return true;
	} else {
		return false;
	}
}

(function ($) {
	if (joinUsForm.length != 0) {
		//console.log(joinUsValidation);

		const elem = document.querySelector('input[name="dob"]');
		//Create Javascript date of 100 years ago
		var today = new Date();
		var minDate = new Date();
		minDate.setFullYear(today.getFullYear() - 100);
		var maxDate = new Date();
		maxDate.setFullYear(today.getFullYear() - 18);

		function generateDobMsg(field) {
			//Add HTML after field
			field.after('<ul class="parsley-errors-list filled" id="parsley-id-16" aria-hidden="false"><li class="parsley-custom-error-message">Please enter a date of birth</li></ul>');
		}

		//Set datepicker options
		var dateChanged = false;
		var options = {
			format: "dd/mm/yyyy",
			format: {
				toValue(dateStr) {
					//Find field name
					var fieldName = $(this);
					//console.log(fieldName);

					let date;
					dateChanged = true;
					//if dateStr is dd/mm/yyyy format
					if (dateStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
						date = new Date(Datepicker.parseDate(dateStr, "dd/mm/yyyy", "en"));
						dateChanged = false;
					} else if (dateStr.match(/^\d{2}\/\d{2}\/\d{2}$/)) {
						date = new Date(Datepicker.parseDate(dateStr, "dd/mm/yy", "en"));
						const year = date.getFullYear();
						date.setFullYear(year + (year < 50 ? 2000 : 1900));
					} else if (dateStr.match(/^\d{1}\/\d{1}\/\d{2}$/)) {
						date = new Date(Datepicker.parseDate(dateStr, "d/m/yy", "en"));
						const year = date.getFullYear();
						date.setFullYear(year + (year < 50 ? 2000 : 1900));
					} else if (dateStr.match(/^\d{1}\/\d{2}\/\d{2}$/)) {
						date = new Date(Datepicker.parseDate(dateStr, "d/mm/yy", "en"));
						const year = date.getFullYear();
						date.setFullYear(year + (year < 50 ? 2000 : 1900));
					} else if (dateStr.match(/^\d{2}\/\d{1}\/\d{2}$/)) {
						date = new Date(Datepicker.parseDate(dateStr, "dd/m/yy", "en"));
						const year = date.getFullYear();
						date.setFullYear(year + (year < 50 ? 2000 : 1900));
					} else {
						date = new Date(Datepicker.parseDate(dateStr, "dd/m/yy", "en"));
						dateChanged = false;
					}
					return date;
				},
				toDisplay(date) {
					return Datepicker.formatDate(date, "dd/mm/yyyy", "en");
				},
			},
			minDate: minDate,
			maxDate: maxDate,
		};

		const datepicker = new Datepicker(elem, options);

		console.log('datepicker');
		console.log(datepicker);

		//On datepicker change
		elem.addEventListener("changeDate", function (event) {
			$(this).siblings(".parsley-errors-list").remove();
			if (dateChanged) {
				$(this).after('<ul class="parsley-errors-list filled" id="parsley-id-16" aria-hidden="false"><li class="parsley-custom-error-message text-yellow-500	">Please check the date of birth entered</li></ul>');
			}
		});

		const person2_dob_elem = document.querySelector('input[name="person2_dob"]');
		const datepicker2 = new Datepicker(person2_dob_elem, options);
		person2_dob_elem.addEventListener("changeDate", function (event) {
			$(this).siblings(".parsley-errors-list").remove();
			if (dateChanged) {
				$(this).after('<ul class="parsley-errors-list filled" id="parsley-id-16" aria-hidden="false"><li class="parsley-custom-error-messag text-yellow-500	">Please check the date of birth entered</li></ul>');
			}
		});

		$(document).on("keydown", ".select2-title,.select2-person2-title", function (e) {
			if (e.originalEvent && e.which == 40) {
				e.preventDefault();
				$(this).siblings("select").select2("open");
			}
		});

		$(".select2-title,.select2-person2-title").select2({
			dropdownAutoWidth: true,
			width: "100%",
			selectOnClose: true,
		});

		function hideErrorMessage() {
			$(".join-us-error").addClass("hidden");
			$(".join-us-error .message").html("");
		}

		function showErrorMessage(message) {
			$(".join-us-error").removeClass("hidden");
			$(".join-us-error .message").html(message);

			//Scroll to error message
			$("html, body").animate(
				{
					scrollTop: $(".join-us-error").offset().top - 10,
				},
				200
			);
		}

		$(document).on("click", ".manual-address", function (e) {
			manualAddress = true;
			//Make address1_line1 required
			$('input[name="address1_line1"]').attr("required", "required");
		});

		$("#coupleJoin").change(function () {
			console.log("CoupleJoin change event fired! Current value:", $(this).val());
			if ($("#coupleJoin").val() === "1") {
				$(".couple").removeClass("hidden");
				//Add parsley required to couple fields
				$("#person2_title").attr("data-parsley-required", "true");
				$("#person2_firstName").attr("data-parsley-required", "true");
				$("#person2_lastName").attr("data-parsley-required", "true");
			} else {
				$(".couple").addClass("hidden");
				$("#person2_title").attr("data-parsley-required", "false");
				$("#person2_firstName").attr("data-parsley-required", "false");
				$("#person2_lastName").attr("data-parsley-required", "false");
			}
		});

		const $individualButton = $(".type-of-membership .individualbtn");
		const $coupleButton = $(".type-of-membership .couplebtn");
		const $coupleJoinHiddenInput = $("#coupleJoin");

		// Function to set active button and update hidden input
		function setMembershipType(type) {
			if (type === "individual") {
				$individualButton.addClass("bg-primary-200 text-white").removeClass("bg-white text-primary-200");
				$coupleButton.removeClass("bg-primary-200 text-white").addClass("bg-white text-primary-200");
				$coupleJoinHiddenInput.val("0"); // '0' for individual
			} else if (type === "couple") {
				$coupleButton.addClass("bg-primary-200 text-white").removeClass("bg-white text-primary-200");
				$individualButton.removeClass("bg-primary-200 text-white").addClass("bg-white text-primary-200");
				$coupleJoinHiddenInput.val("1"); // '1' for couple
			}

			// Trigger the change event on the hidden input
			// This will fire all your existing $("#coupleJoin").change() handlers
			$coupleJoinHiddenInput.trigger("change");
		}

		// 1. Set initial state on page load
		// Assuming 'Individual' is active by default (value='0' in HTML)
		// No need to explicitly call setMembershipType unless you want to re-evaluate based on a pre-set value
		// If you need to ensure the correct button is styled on page load based on hidden input's initial value:
		console.log($coupleJoinHiddenInput.val());
		if ($coupleJoinHiddenInput.val() === "1") {
			setMembershipType("couple");
		} else {
			setMembershipType("individual");
		}

		// 2. Add click handlers to the buttons
		$individualButton.on("click", function () {
			console.log("Individual button clicked");
			setMembershipType("individual");
		});

		$coupleButton.on("click", function () {
			console.log("Couple button clicked");
			setMembershipType("couple");
		});

		$(document).ready(function () {
			var utmSource = getUrlParameter("utm_source");
			var utmCampaign = getUrlParameter("utm_campaign");
			var utmMedium = getUrlParameter("utm_medium");

			//console.log('utmSource: ' + utmSource);

			var utmSourceMatched = false;

			if (utmSource === "speaking_engagement" || utmSource === "speaker") {
				//console.log('utm 1');
				//replace _ with space and capitalise first letter of each word in utm_campaign
				utmCampaign = utmCampaign.replace(/_/g, " ").replace(/\w\S*/g, function (txt) {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				});

				//Find option in #source dropdown with value of Speaker, select it
				$("#source").find('option[value="Speaker"]').prop("selected", true);

				//Trigger change on #source
				$("#source").trigger("change");

				// Set the specific speaker based on the utm_campaign
				$("#speaker")
					.find("option")
					.each(function () {
						if ($(this).val() === utmCampaign) {
							$(this).prop("selected", true);
							return false; // Break the loop
						}
					});

				if (utmCampaign == "opc") {
					$("#source").find('option[value="project"]').prop("selected", true).trigger("change");

					$("#project").find('option[value="One People Commission"]').prop("selected", true);
				}
				utmSourceMatched = true;
			} else if (utmSource === "talkingjesus") {
				//console.log('utm 2');
				$("#source").find('option[value="Talking Jesus"]').prop("selected", true).trigger("change");
				utmSourceMatched = true;
			} else if (utmMedium === "event") {
				$("#source").find('option[value="Event"]').prop("selected", true).trigger("change");
				utmSourceMatched = true;
			} else if (
				utmMedium === "social" ||
				(utmMedium && utmMedium.toLowerCase().indexOf("social") !== -1) ||
				utmSource === "ig" ||
				utmSource === "fb" ||
				utmSource === "facebook" ||
				utmSource === "instagram"
			) {
				$("#source").find('option[value="Social media"]').prop("selected", true).trigger("change");
				utmSourceMatched = true;
			} else if (utmMedium === "organic" || utmMedium === "cpc") {
				$("#source").find('option[value="Search engine"]').prop("selected", true).trigger("change");
				utmSourceMatched = true;
			} else if (utmSource == "team") {
				//Select other
				$("#source").find('option[value="other"]').prop("selected", true).trigger("change");
				if (utmCampaign) {
					$("#other_source").val(utmCampaign);
				}
				utmSourceMatched = true;
			}

			// Hide source fields when UTM parameters have pre-selected the source
			if (utmSourceMatched) {
				$("#source_container").addClass("hidden");
				$("#other_source_container").addClass("hidden");
				$("#speakerOptions").addClass("hidden");
				$("#eventOptions").addClass("hidden");
				$("#projectOptions").addClass("hidden");
				$("#podcastOptions").addClass("hidden");
				$("#source").attr("data-parsley-required", "false");
				$("#other_source").attr("data-parsley-required", "false");
				$("#speaker").attr("data-parsley-required", "false");
				$("#event").attr("data-parsley-required", "false");
				$("#project").attr("data-parsley-required", "false");
				$("#podcast").attr("data-parsley-required", "false");
			}

			const uap = new UAParser();

			// Extract Google Analytics Client ID from the '_ga' cookie
			var gaCookie = document.cookie.split("; ").find((row) => row.startsWith("_ga="));
			if (gaCookie) {
				var clientId = gaCookie.split("=")[1].split(".").slice(2).join(".");
				document.getElementById("gaClientId").value = clientId;
			}

			// Capture browser and operating system details using UAParser
			const browserInfo = uap.getBrowser();
			const osInfo = uap.getOS();

			// Populate hidden fields for browser and operating system
			document.getElementById("browser").value = browserInfo.name + " " + browserInfo.version;
			document.getElementById("operatingSystem").value = osInfo.name + " " + osInfo.version;

			// Capture UTM parameters from URL and set hidden input fields
			document.getElementById("utm_campaign").value = getUrlParameter("utm_campaign") || "";
			document.getElementById("utm_medium").value = getUrlParameter("utm_medium") || "";
			document.getElementById("utm_source").value = getUrlParameter("utm_source") || "";
			document.getElementById("utm_term").value = getUrlParameter("utm_term") || "";
			document.getElementById("utm_content").value = getUrlParameter("utm_content") || "";

			//Membership type
			membershipType = getUrlParameter("membership_type");
			if (membershipType) {
				$("#membership_type").val(membershipType);
				if (membershipType === "bothlives") {
					$(".membership-type-addition.bothlives").removeClass("hidden");
				} else if (membershipType === "publicleadership") {
					$(".membership-type-addition.publicleadership").removeClass("hidden");
				}
			}

			// Set video to joinUsForm data-video value
			showVideo = joinUsForm.data("video");
			if (showVideo) {
				$(".membership-type-addition.video").removeClass("hidden");
			}
		});

		$("#source").change(function () {
			if ($(this).val() == "Speaker") {
				$("#speakerOptions").removeClass("hidden");
				$("#speaker").attr("data-parsley-required", "true");
			} else {
				$("#speakerOptions").addClass("hidden");
				$("#speaker").attr("data-parsley-required", "false");
			}
			if ($(this).val() == "Event") {
				$("#eventOptions").removeClass("hidden");
				$("#event").attr("data-parsley-required", "true");
			} else {
				$("#eventOptions").addClass("hidden");
				$("#event").attr("data-parsley-required", "false");
			}
			if ($(this).val() == "project") {
				$("#projectOptions").removeClass("hidden");
				$("#project").attr("data-parsley-required", "true");
			} else {
				$("#projectOptions").addClass("hidden");
				$("#project").attr("data-parsley-required", "false");
			}
			if ($(this).val() == "podcast") {
				$("#podcastOptions").removeClass("hidden");
				$("#podcast").attr("data-parsley-required", "true");
			} else {
				$("#podcastOptions").addClass("hidden");
				$("#podcast").attr("data-parsley-required", "false");
			}
			if ($(this).val() == "other") {
				$("#other_source_container").removeClass("hidden");
				$("#other_source").attr("data-parsley-required", "true");
			} else {
				$("#other_source_container").addClass("hidden");
				$("#other_source").attr("data-parsley-required", "false");
			}
		});

		function requiredCheck(page) {
			var section = joinUsForm.find(".section-" + page);
			var fields = section.find("input,select,textarea,radio,checkbox");
			var allValid = true;

			//console.log('requiredCheck for page '+page);

			$(".person-2-required").addClass("hidden");

			fields.each(function () {
				var field = $(this).parsley();
				var isValid = field.validate();
				var errorMessageDiv = $(this).next(".error-message");

				// Special handling for Select2 fields
				if ($(this).hasClass("select2-hidden-accessible")) {
					var select2Container = $(this).next(".select2-container");
					if (isValid !== true) {
						select2Container.addClass("error");
					} else {
						select2Container.removeClass("error");
					}
				}

				// Special handling for phone number
				if ($(this).attr("name") == "phone") {
					if (validatePhone($(this).attr("id")) == false) {
						isValid = false;

						//Remove parsley error message
						$(this).parsley().removeError("custom", { updateClass: true });

						//Trigger parsley error message
						$(this).parsley().addError("custom", {
							message: "Please enter a valid phone number",
						});
					}
				}

				// If couple selected check that person 2 email is not the same as person 1
				if ($("#coupleJoin").val() === "1") {
					if ($(this).attr("name") == "person2_email") {
						if ($(this).val() == $("#email").val()) {
							//Remove parsley error message
							$(this).parsley().removeError("custom", { updateClass: true });

							//Trigger parsley error message
							$(this).parsley().addError("custom", {
								message: "Please enter a different email address to person 1",
							});
							isValid = false;
						}
					}
				}

				if (isValid !== true) {
					//On input of this check if is valid and remove the parsley error message
					$(this).on("input", function () {
						if ($(this).parsley().isValid()) {
							$(this).removeClass("border-red-500 parsley-error is-invalid").addClass("is-valid");
							$(this).siblings(".error-message, .parsley-errors-list").remove();
						}
					});

					//If field starts with person2
					if ($(this).attr("name").startsWith("person2")) {
						$(".person-2-required").removeClass("hidden");
					}

					var name = $(this).attr("name");
					//console.log($(this).attr("name") + ": Invalid");
					if (name == "address1_line1" || name == "address1_postalcode") {
						$('input[name="address_search"]').addClass("border-red-500");
						//Add parsley invalid message to address_search
						var addressSearchField = $('input[name="address_search"]');
						addressSearchField.parsley().removeError("custom");
						addressSearchField.parsley().addError("custom", {
							message: "Please select an address",
						});

						addressSearchField.on("input", function () {
							$(this).removeClass("border-red-500 parsley-error is-invalid").addClass("is-valid");
							$(this).siblings(".error-message, .parsley-errors-list").remove();
						});
						allValid = false;
					} else {
						allValid = false;
						$(this).addClass("border-red-500"); // Tailwind class to highlight the border
					}
				} else {
					//console.log($(this).attr('name') + ': Valid');
					$(this).removeClass("border-red-500");
				}
			});

			if (allValid) {
				//console.log('Section Validated');
				hideErrorMessage();
				return true;
			} else {
				//console.log('Section Not Valid');
				var errorMessage = "Please fill in all of the required fields.";
				showErrorMessage(errorMessage);
				return false;
			}
		}

		function changeIndicator(page) {
			//console.log('Change indicator for page '+page);

			if (page == 1) {
				joinUsForm.find(".steps").addClass("hidden").removeClass("sm:flex");
			} else {
				if (!freeMembership) {
					joinUsForm.find(".steps").removeClass("hidden").addClass("hidden sm:flex");
				}
			}

			//Remove indicators from all
			var otherSteps = joinUsForm.find(".steps").find("[data-page]");
			otherSteps.find(".flex").removeClass("bg-primary-400 text-white rounded p-2");

			//Add checked indicator to previous
			var previousSteps = otherSteps.filter(function () {
				return parseInt($(this).attr("data-page")) < page;
			});

			previousSteps.addClass("cursor-pointer text-primary-200 hover:opacity-75");
			previousSteps.find(".flex").find(".indicator").html('<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" class="w-4 h-4 mr-2 sm:w-5 sm:h-5" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" clip-rule="evenodd"/></svg>');

			//Add number to future steps
			var nextSteps = otherSteps.filter(function () {
				return parseInt($(this).attr("data-page")) >= page;
			});

			nextSteps.removeClass("cursor-pointer text-primary-200 hover:opacity-75");
			nextSteps.each(function (i, obj) {
				$(this)
					.find(".flex")
					.find(".indicator")
					.html('<span class="mr-2">' + parseInt($(this).attr("data-page")) + "</span>");
			});

			//Current step style change

			var step = joinUsForm.find(".steps").find('[data-page="' + page + '"]');
			step.find(".flex").addClass("bg-primary-400 text-white rounded p-2");
		}

		function outputGiftAidDate(date) {
			var options = { day: "numeric", month: "long", year: "numeric" };
			var formattedDate = date.toLocaleDateString("en-US", options);

			var day = date.getDate();
			var month = date.toLocaleString("default", { month: "long" });
			var year = date.getFullYear();

			var formattedDate = day + " " + month + " " + year;
			return formattedDate;
		}

		function changePage(page, check) {
			if (!(page > 0 && page < 6)) return false;
			if (check && !requiredCheck(currentPage)) return false;

			hideErrorMessage();

			joinUsForm.find(".section").addClass("hidden");
			joinUsForm.find(".section-" + page).removeClass("hidden");

			var previousPage = currentPage;
			currentPage = page;
			joinUsForm.data("page", page);

			// Remove Parsley validation when changing the page
			var currentSection = joinUsForm.find(".section-" + currentPage);
			currentSection.find("input, select").each(function () {
				$(this).parsley().reset();
				$(this).removeClass("border-red-500");
			});

			console.log("");
			console.log("Go to page: " + page);
			console.log("prevPage: " + prevPage);
			console.log("currentPage: " + currentPage);

			if (currentPage < 6) {
				joinUsForm.find(".section").addClass("hidden");
				joinUsForm.find(".section-" + page).removeClass("hidden");

				//Scroll to .sections
				$("html, body").animate(
					{
						scrollTop: $(".sections").offset().top - 10,
					},
					200
				);

				//prevPage++;
				//currentPage++;
				//nextPage++;

				currentPage = page;
				joinUsForm.data("page", page);
				setTimeout(function (e) {
					resetSubmitBtn();
				}, 500);
			}

			newPage = page;
			prevPage = newPage - 1;
			nextPage = newPage + 1;

			//Indicator
			//changeIndicator(prevPage);
			changeIndicator(newPage);

			if (newPage == 2) {
				$(".membership-page").addClass("hidden");

				updateGiftAidAmounts();
			}

			if (newPage == 3) {
				joinUsForm.find(".dd-amount").text(
					donationAmount.toLocaleString("en-GB", {
						style: "currency",
						currency: "GBP",
					})
				);
			}

			if (newPage == 4) {
				joinUsForm.find(".confirm-title").text($("#title").find("option:selected").text());
				joinUsForm.find(".confirm-firstname").text($("#firstName").val());
				joinUsForm.find(".confirm-lastname").text($("#lastName").val());
				joinUsForm.find(".confirm-sex").text($("#gender").find("option:selected").text());
				joinUsForm.find(".confirm-dob").text($("#dob").val());
				joinUsForm.find(".confirm-email").text($("#email").val());
				joinUsForm.find(".confirm-phone").text($("#phone").val());

				if ($("#coupleJoin").val() === "1") {
					$(".confirm-person2").removeClass("hidden");
					joinUsForm.find(".confirm-person2-title").text($("#person2_title").find("option:selected").text());
					joinUsForm.find(".confirm-person2-firstname").text($("#person2_firstName").val());
					joinUsForm.find(".confirm-person2-lastname").text($("#person2_lastName").val());
					joinUsForm.find(".confirm-person2-sex").text($("#person2_gender").find("option:selected").text());
					joinUsForm.find(".confirm-person2-dob").text($("#person2_dob").val());
					joinUsForm.find(".confirm-person2-email").text($("#person2_email").val());

					joinUsForm.find(".confirm-gift-aid-payer").text($("#taxpayer").find("option:selected").text());
				} else {
					$(".confirm-person2").addClass("hidden");
				}

				joinUsForm.find(".confirm-address-name").text($("#address1_name").val());
				joinUsForm.find(".confirm-address-1").text($("#address1_line1").val());
				joinUsForm.find(".confirm-address-2").text($("#address1_line2").val());
				joinUsForm.find(".confirm-address-3").text($("#address1_line3").val());
				joinUsForm.find(".confirm-city").text($("#address1_city").val());
				joinUsForm.find(".confirm-postcode").text($("#address1_postalcode").val());

				if ($("#gift_aid").is(":checked")) {
					joinUsForm.find(".confirm-gift-aid").text("Yes");
					joinUsForm.find(".gift-aid-date").removeClass("hidden");

					//If user has selected giftaid_startdate
					if ($("#giftaid_startdate").val() != "") {
						var dateString = $("#giftaid_startdate").val();
						var dateParts = dateString.split("-");
						var year = parseInt(dateParts[0]);
						var month = parseInt(dateParts[1]) - 1; // Months are zero-based in JavaScript
						var day = parseInt(dateParts[2]);

						var dateObject = new Date(year, month, day);

						var formattedDate = outputGiftAidDate(dateObject);

						joinUsForm.find(".confirm-gift-aid-start-date").text(formattedDate);
					} else {
						// Create j F Y date
						// Create a new Date object
						var today = new Date();
						// Get the current year
						var currentYear = today.getFullYear();
						var fourYearsAgo = currentYear - 4;

						// Set the date to April 6 of four years ago
						var previousApril = new Date(fourYearsAgo, 3, 6);

						var formattedDate = outputGiftAidDate(previousApril);

						joinUsForm.find(".confirm-gift-aid-start-date").text(formattedDate);
					}
				} else {
					joinUsForm.find(".confirm-gift-aid").text("No");
					joinUsForm.find(".gift-aid-date").addClass("hidden");
				}

				joinUsForm.find(".confirm-account-holder").text($("#accountname").val());
				joinUsForm.find(".confirm-account-number").text($("#accountnumber").val());
				joinUsForm.find(".confirm-sort-code").text($("#sortcode").val());
			}

			$(".membership-type-addition").addClass("hidden");
			if (newPage == 1) {
				$("#join-us-form").removeClass("sm:w-full").addClass("lg:w-6/12");
				if (membershipType === "bothlives") {
					$(".membership-type-addition.bothlives").removeClass("hidden");
				} else if (membershipType === "publicleadership") {
					$(".membership-type-addition.publicleadership").removeClass("hidden");
				} else if (showVideo) {
					$(".membership-type-addition.video").removeClass("hidden");
				}
			} else if (newPage == 2) {
				$("#join-us-form").removeClass("lg:w-6/12").addClass("sm:w-full");
			}

			// If user is going backwards, reset tracking for future pages
			if (page < previousPage) {
				resetTrackingForFuturePages(page - 1);
			}

			//Track page change
			if (newPage >= 2) {
				trackPageSubmission(prevPage);
				entryTime = Date.now();
			}
		}

		function trackPageSubmission(pageNumber) {
			if (!trackedPages["page" + pageNumber]) {
				var exitTime = Date.now(); // Record exit time
				var timeSpent = (exitTime - entryTime) / 1000; // Time spent in seconds

				sendEvent("paperless_dd", trackingName, "Interaction", "Page " + pageNumber, timeSpent, false);

				console.log("Tracked page " + pageNumber + " after " + timeSpent + " seconds");
				if (pageNumber == 1) {
					console.log("begin_checkout");
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: "begin_checkout",
						step_number: 1,
						membership_type: "personal membership",
						page_referrer: document.referrer || "direct", // where they came from
					});
				} else if (pageNumber == 2) {
					if (donationAmount) {
						var donation_amount_type = "Default";
					} else {
						var donation_amount_type = "Custom";
					}

					if ($("#coupleJoin").val() === "1") {
						var membership_option = "Couple";
					} else {
						var membership_option = "Individual";
					}

					if ($("#gift_aid").is(":checked")) {
						var gift_aid_status = "True";
					} else {
						var gift_aid_status = "False";
					}

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ ecommerce: null });
					window.dataLayer.push({
						event: "details_step",
						step_number: 2,
						membership_type: "personal membership",
						page_referrer: document.referrer || "direct",
						membership_option: membership_option, // or 'Couple'
						donation_amount_type: donation_amount_type,
						currency: "GBP",
						value: donationAmount, // donation amount
						gift_aid_status: gift_aid_status,
						ecommerce: {
							currency: "GBP",
							value: donationAmount, // donation amount
							items: [
								{
									item_name: "Personal Membership",
									item_category: membership_option, // or 'Couple'
									price: donationAmount,
									quantity: 1,
								},
							],
						},
					});
				} else if (pageNumber == 3) {
					if (donationAmount) {
						var donation_amount_type = "Default";
					} else {
						var donation_amount_type = "Custom";
					}

					if ($("#coupleJoin").val() === "1") {
						var membership_option = "Couple";
					} else {
						var membership_option = "Individual";
					}

					if ($("#gift_aid").is(":checked")) {
						var gift_aid_status = "True";
					} else {
						var gift_aid_status = "False";
					}

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ ecommerce: null });
					window.dataLayer.push({
						event: "add_payment_info",
						step_number: 3,
						membership_type: "personal membership",
						page_referrer: document.referrer || "direct", // where they came from
						membership_option: membership_option, // or 'Couple'
						donation_amount_type: donation_amount_type, // or 'Custom'
						currency: "GBP",
						value: donationAmount, // donation amount
						gift_aid_status: gift_aid_status,
						ecommerce: {
							currency: "GBP",
							value: donationAmount, // donation amount
							items: [
								{
									item_name: "Personal Membership",
									item_category: membership_option, // or 'Couple'
									price: donationAmount,
									quantity: 1,
								},
							],
						},
					});
				}

				trackedPages["page" + pageNumber] = true; // Mark as tracked
			}
		}

		// Add this new function to reset tracking for future pages when going backwards
		function resetTrackingForFuturePages(currentPageNumber) {
			for (let i = currentPageNumber + 1; i <= 4; i++) {
				trackedPages["page" + i] = false;
			}
		}

		$(document).on("click", ".steps li", function (e) {
			page = $(this).data("page");
			if (page < currentPage) {
				changePage(page, false);
			}
		});

		//Use jquery to check when the input other_amount has a number in and uncheck the input donation_amount
		$(document).on("input", 'input[name="other_amount"]', function (e) {
			if ($(this).val() != "") {
				joinUsForm.find('input[name="donation_amount"]').prop("checked", false);
				var donationAmount = parseFloat($(this).val());

				if (donationAmount <= 0) {
					freeMembership = true;
				} else {
					freeMembership = false;
				}
			}
		});

		//This allows the user to enter decimal values if wanted, but changes the step to a whole number so the default up/down is a whole number
		$('input[name="other_amount"]')
			.on("keydown", function (e) {
				if (e.which === 38 || e.which === 40) {
					// Up or Down arrow keys
					$(this).attr("step", 1);
				}
			})
			.on("focus", function () {
				$(this).attr("step", 1);
			})
			.on("blur", function () {
				$(this).attr("step", 0.01);
				//If the value is empty, set it to 0
				if ($(this).val() == "") {
					$(this).val(0);
				}
			});

		//Use jquery to check when the input donation_amount has been checked and make the other_amount value empty
		$(document).on("click", 'input[name="donation_amount"]', function (e) {
			if ($(this).is(":checked")) {
				joinUsForm.find('input[name="other_amount"]').val("");
				//Get the value of the checked radio button donation_amount and pass it to the variable donationAmount
				donationAmount = parseFloat($(this).val());

				if (donationAmount <= 0) {
					freeMembership = true;
					$(".giftaid").addClass("hidden");
				} else {
					freeMembership = false;
					$(".giftaid").removeClass("hidden");
				}

				updateGiftAidAmounts();
			}
		});

		function updateGiftAidAmounts() {
			console.log("Update gift aid amounts with donationAmount: " + donationAmount);
			joinUsForm.find(".donation-amt").text(
				donationAmount.toLocaleString("en-GB", {
					style: "currency",
					currency: "GBP",
				})
			);
			joinUsForm.find(".giftaid-amt").text(
				parseFloat(donationAmount * 1.25).toLocaleString("en-GB", {
					style: "currency",
					currency: "GBP",
				})
			);

			if (freeMembership) {
				//Find button with name "next" and value "page3" and change text to "Join us today"
				joinUsForm.find('button[name="next"][value="page3"]').text("Join us today");
			} else {
				joinUsForm.find('button[name="next"][value="page3"]').text("Next >");
			}
		}

		//When gift_aid is checked
		$(document).on("click", 'input[name="gift_aid"]', function (e) {
			$(".giftaid_choose").addClass("hidden");
			if ($(this).is(":checked")) {
				//if coupleJoin is checked
				if ($("#coupleJoin").val() === "1") {
					//Get person 1 name
					var person1Title = $("#title").find("option:selected").text();
					var person2Title = $("#person2_title").find("option:selected").text();

					var person1Name = person1Title + " " + $("#firstName").val() + " " + $("#lastName").val();
					//Get person 2 name
					var person2Name = person2Title + " " + $("#person2_firstName").val() + " " + $("#person2_lastName").val();

					//Add names to taxpayer dropdown
					$("#taxpayer").html('<option value="person1">' + person1Name + '</option><option value="person2">' + person2Name + "</option>");

					$(".giftaid_choose").removeClass("hidden");
				}
			}
		});

		$(document).on("input", 'input[name="accountnumber"]', function (e) {
			let cleanedVal = $(this)
				.val()
				.replace(/[^0-9]/g, "")
				.substr(0, 8);
			$(this).val(cleanedVal);
		});

		$(document).on("keydown", 'input[name="sortcode"]', function (e) {
			const allowedKeyCodes = [8, 9, 46, 35, 36, 37, 39, 109, 189]; // Backspace, Tab, Delete, Home, End, Left Arrow, Right Arrow, Numpad "-", Standard "-"
			const numericKeyCodes = Array.from({ length: 10 }, (_, i) => i + 48); // 0-9
			const numericNumpadKeycodes = Array.from({ length: 10 }, (_, i) => i + 96); // Numpad 0-9

			const allAllowedKeys = [...allowedKeyCodes, ...numericKeyCodes, ...numericNumpadKeycodes];

			if (allAllowedKeys.includes(e.keyCode)) {
				return true;
			}

			e.preventDefault();
		});

		$(document).on("input", 'input[name="sortcode"]', function () {
			let value = $(this)
				.val()
				.replace(/[^0-9]/g, "")
				.substr(0, 6);
			let formattedValue = "";

			for (let i = 0; i < value.length; i++) {
				if (i > 0 && i % 2 === 0) {
					formattedValue += "-";
				}
				formattedValue += value[i];
			}

			$(this).val(formattedValue);
		});

		function showLoading() {
			// Center the screen on the .loader element
			const loader = $(".loader");
			const windowHeight = $(window).height();
			const loaderHeight = loader.outerHeight();
			const scrollTop = loader.offset().top - (windowHeight - loaderHeight) / 2;
			$("html, body").scrollTop(scrollTop);

			$(".loading-screen").removeClass("hidden");
			$(".loading-screen .loading-message").html("Please wait, checking your details");

			//Scroll so loading-message is in the center of the screen
			const loadingMessage = $(".loading-message");
			const loadingMessageHeight = loadingMessage.outerHeight();
			const scrollTopMessage = loadingMessage.offset().top - (windowHeight - loadingMessageHeight) / 2;
			$("html, body").scrollTop(scrollTopMessage);
		}

		function hideLoading() {
			$(".loading-screen").addClass("hidden");
		}

		function showDonationPrompt() {
			$(".donation-prompt").removeClass("hidden");
		}

		function hideDonationPrompt() {
			$(".donation-prompt").addClass("hidden");
		}

		$(document).on("click", ".donation-prompt-yes", function (e) {
			hideDonationPrompt();

			// Move the user onto a paid donation by preselecting the lowest amount.
			joinUsForm.find('input[name="other_amount"]').val("");
			joinUsForm.find('input[name="donation_amount"]').first().prop("checked", true).trigger("click");

			// Scroll back to the donation field so they can confirm or adjust.
			const donationSection = $(".section-2-section.donation");
			if (donationSection.length) {
				$("html, body").animate(
					{
						scrollTop: donationSection.offset().top - 10,
					},
					200
				);
			}
		});

		// Decline: just close the prompt and let the user resume. The next click of
		// the "Join us today" button submits the free membership (gate now passes).
		$(document).on("click", ".donation-prompt-no", function (e) {
			donationPromptDismissed = true;
			hideDonationPrompt();
		});

		// Treat a backdrop click or Esc as a passive dismiss (proceed on next click).
		$(document).on("click", ".donation-prompt", function (e) {
			if (e.target === this) {
				donationPromptDismissed = true;
				hideDonationPrompt();
			}
		});

		$(document).on("keydown", function (e) {
			if (e.keyCode === 27 && !$(".donation-prompt").hasClass("hidden")) {
				donationPromptDismissed = true;
				hideDonationPrompt();
			}
		});

		$(document).on("click", 'button[name="next"]', (e) => {
			pageSubmit();
			return false;
		});

		$(document).on("click", 'button[name="back"]', (e) => {
			changePage(currentPage - 1, false);
			return false;
		});

		$(document).on("input", 'input[name="other_amount"]', function () {
			// Show/hide based on value

			if ($(this).val() == 0) {
				freeMembership = true;
				$(".free-membership-contact").removeClass("hidden");
				$(".giftaid").addClass("hidden");
			} else {
				freeMembership = false;
				$(".free-membership-contact").addClass("hidden");
				$(".giftaid").removeClass("hidden");
			}

			donationAmount = parseFloat($(this).val());

			updateGiftAidAmounts();
		});

		// Optionally, handle Enter key for submission
		$(document).on("keydown", 'input[name="other_amount"]', function (e) {
			if (e.keyCode == 13) {
				pageSubmit();
				return false;
			}
		});

		function createMemberCall(formData) {
			// Submit Form Data
			createMember(formData)
				.then((response) => {
					var success = response.success;
					if (success) {
						hideLoading();

						var membernumber = null;

						//If response.contact.py3_recordnumber is defined and not null
						if (response.contact.py3_recordnumber) {
							$("#contact-num").html(response.contact.py3_recordnumber);
							membernumber = response.contact.py3_recordnumber;
						}
						$(".sections").addClass("hidden");
						$(".confirmation.success").removeClass("hidden");

						if (freeMembership) {
							$(".confirmation .direct-debit").addClass("hidden");
						}

						//Send event to Google Analytics
						//If joint member
						let membership_option;
						if ($("#coupleJoin").val() === "1") {
							membership_option = "Couple";
							sendEvent("paperless_dd", trackingName, "New member", "New joint member", donationAmount, false);
						} else {
							membership_option = "Individual";
							sendEvent("paperless_dd", trackingName, "New member", "New member", donationAmount, false);
						}

						const donation_amount_type = donationAmount ? "Default" : "Custom";

						const gift_aid_status = $("#gift_aid").is(":checked") ? "True" : "False";

						if (!membernumber) {
							membernumber = "M_" + Math.floor(Math.random() * 1000000);
						}

						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({ ecommerce: null });
						window.dataLayer.push({
							event: "purchase",
							step_number: 4,
							membership_type: "personal membership",
							page_referrer: document.referrer || "direct", // where they came from
							membership_option: membership_option, // or 'Couple'
							donation_amount_type: donation_amount_type, // or 'Custom'
							currency: "GBP",
							value: donationAmount,
							gift_aid_status: gift_aid_status,
							ecommerce: {
								transaction_id: membernumber,
								currency: "GBP",
								value: donationAmount, // donation amount
								items: [
									{
										item_name: "Personal Membership",
										item_category: membership_option, // or 'Couple'
										price: donationAmount,
										quantity: 1,
									},
								],
							},
						});

						window.dataLayer.push({
							event: "newMember",
							event_value: parseInt(donationAmount, 10),
						});
					} else if (!success) {
						hideLoading();

						if (response.contact) {
							$("#error-contact-num").html(" referencing number " + response.contact);
						}
						$(".sections").addClass("hidden");
						$(".confirmation.error").removeClass("hidden");

						//Send event to Google Analytics
						sendEvent("paperless_dd", trackingName, "Creation failure", "Unknown error", null, false);
					}
				})
				.catch(() => {
					hideLoading();
					$(".sections").addClass("hidden");
					$(".confirmation.error").removeClass("hidden");

					//Send event to Google Analytics
					sendEvent("paperless_dd", trackingName, "Creation failure", "Unknown error", null, false);
				});
		}

		function pageSubmit() {
			//console.log('submit');
			const currentPage = joinUsForm.data("page");

			if (currentPage === 2 && freeMembership) {
				if (!requiredCheck(currentPage)) return false;

				if (!donationPromptDismissed) {
					showDonationPrompt();
					return false;
				}

				showLoading();
				$(".loading-screen .loading-message").html("Creating your membership");

				// Get Form Data
				const formData = joinUsForm.serializeArray();

				// Append CSRF Token
				appendCsrfField(formData);

				createMemberCall(formData);
			} else if (currentPage === 4) {
				if (!requiredCheck(currentPage)) return false;
				//console.log('submit for real');
				showLoading();

				verifyIdentity()
					.then((response) => {
						//console.log(response);
						//console.log(response.success);
						//console.log('response was');
						if (response.success === true) {
							$(".loading-screen .loading-message").html("Details verified, setting up your Direct Debit");

							// Get Form Data
							const formData = joinUsForm.serializeArray();

							//Remove hyphens from sortcode
							formData.forEach((field) => {
								if (field.name === "sortcode") {
									field.value = field.value.replace(/-/g, "");
								}
							});

						// Append CSRF Token
						appendCsrfField(formData);

							createMemberCall(formData);
						} else if (response.success === false) {
							hideLoading();

							showErrorMessage('<strong>Bank verification failed</strong><br>Sorry, your bank details have not passed our verification tests.<br>If you think this is a mistake, please <a class="underline hover:no-underline" href="/contact-us">contact us</a>.');

							//Send event to Google Analytics
							sendEvent("paperless_dd", trackingName, "Verification failure", "Bank verification failed", null, false);

							console.log("We have a error");
							if (response.errors) {
								saveErrorSession("bank_verification_failed", response.errors);
							} else {
								saveErrorSession("bank_verification_failed", "Bank verification failed - no response error");
							}
						} else {
							console.log("We have a problem");

							//Send event to Google Analytics
							sendEvent("paperless_dd", trackingName, "Verification failure", "Unknown error", null, false);
							saveErrorSession("bank_verification_failed", "Bank verification failed - other unknown");
						}
					})
					.catch((error) => {
						//Send event to Google Analytics
						sendEvent("paperless_dd", trackingName, "Verification failure", "Unknown error", null, false);

						saveErrorSession("bank_verification_failed", "Unknown error");

						showErrorMessage('<strong>Something went wrong</strong><br>Sorry, something went wrong. Please try again. If you continue to get this error message, please <a class="underline hover:no-underline" href="/contact-us">contact us</a>.');
						console.log(error);
					});

				return false;
			} else {
				prevPage = currentPage - 1;
				nextPage = currentPage + 1;

				changePage(nextPage, true);
			}
		}

		const verifyIdentity = () => {
			return new Promise(async (resolve, reject) => {
				// Get the date input value and split it into components
				const dobValue = $("#dob").val();
				const dobComponents = dobValue.split("/");

				const requestData = applyCsrfToPayload({
					Personal: {
						PersonalDetails: {
							Title: $('input[name="title"]').val(),
							Forename: $('input[name="firstName"]').val(),
							Surname: $('input[name="lastName"]').val(),
							DOBDay: dobComponents[0], // Day component
							DOBMonth: dobComponents[1], // Month component
							DOBYear: dobComponents[2], // Year component
						},
					},
					Addresses: {
						CurrentAddress: {
							Country: "United Kingdom",
							AddressLine1: $('input[name="address1_line1"]').val(),
							AddressLine2: $('input[name="address1_line2"]').val(),
							AddressLine3: $('input[name="address1_line3"]').val(),
							AddressLine4: $('input[name="address1_city"]').val(),
							ZipPostcode: $('input[name="address1_postalcode"]').val(),
						},
					},
					BankingDetails: {
						BankAccount: {
							SortCode: $('input[name="sortcode"]').val().replace(/-/g, ""),
							AccountNumber: $('input[name="accountnumber"]').val(),
						},
					},
				});

				try {
					// Send AJAX request as JSON
					const response = await $.ajax({
						type: "POST",
						url: "/actions/eauk-general/paperless/verify",
						data: JSON.stringify(requestData),
						contentType: "application/json", // Set content type to JSON
						dataType: "json",
					});
					resolve(response);
				} catch (error) {
					saveErrorSession("bank_verification_failed", "Failed to send AJAX request");
					console.log("Error: Failed to send AJAX request.");
					showErrorMessage('<strong>Something went wrong</strong><br>Your bank details have not passed our verification test due to an error.<br>Please try again. If you continue to encounter this error please <a class="underline hover:no-underline" href="/contact-us">contact us</a>.');

					reject("Error: Failed to send AJAX request.");
				}
			});
		};

		const createMember = (formData) => {
			return new Promise((resolve, reject) => {
				$.ajax({
					type: "POST",
					url: "/actions/eauk-general/dynamics/create-new-member",
					data: formData,
				})
					.done((response) => {
						resolve(response);
					})
					.fail((error) => {
						//Send event to Google Analytics
						sendEvent("paperless_dd", trackingName, "Verification failure", "Unknown error", null, false);

						saveErrorSession("create_member_failed", "Error: Failed to send AJAX request for member.");

						showErrorMessage('<strong>Something went wrong</strong><br>Your bank details have passed our verification test, but we failed to set up your membership.<br>Please try again. If you continue to encounter this error please <a class="underline hover:no-underline" href="/contact-us">contact us</a>.');

						console.log("Error: Failed to send AJAX request for member.");
						reject("Error: Failed to send AJAX request for member.");
					});
			});
		};

		function saveErrorSession(errorType, errorDetails) {
			console.log("Save error session");
			// Get Form Data
			const formData = joinUsForm.serializeArray();

			//Remove sortcode and accountnumber from formData
			formData.forEach((field, index) => {
				if (field.name === "sortcode" || field.name === "accountnumber") {
					formData.splice(index, 1);
				}
			});

			// Append CSRF Token
			appendCsrfField(formData);
			formData.push({ name: "errorType", value: errorType });
			formData.push({ name: "errorDetails", value: errorDetails });

			$.ajax({
				type: "POST",
				url: "/actions/eauk-general/paperless/save-error",
				data: formData,
			})
				.done(function (response) {
					console.log("Error posted");
				})
				.fail(function (error) {
					console.log("Error posting error");
				});
		}
	}
})(jQuery);
